import { useState, useEffect } from "react";

import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

export default function IntervalsMenuSelect({
  dateRange,
  setDateRange,
  termRange,
}) {
  const intervalsMenuByTerm = {
    "1D": ["15m", "1H", "3H"],
    "1W": ["1H", "3H", "1D"],
    "1M": ["3H", "1D", "1W"],
    YTD: ["1W", "1M"],
    "1Y": ["1W", "1M"],
    All: ["1W", "1M"],
  };
  const [intervalsMenu, setIntervalsMenu] = useState(
    intervalsMenuByTerm[termRange]
  );

  // useEffect(() => {
  //   setDateRange(intervalsMenu[intervalsMenu.length - 1]);
  // }, []);

  useEffect(() => {
    setIntervalsMenu(intervalsMenuByTerm[termRange]);
    setDateRange(
      intervalsMenuByTerm[termRange][intervalsMenuByTerm[termRange].length - 1]
    );
  }, [termRange]);

  return (
    <FormControl
      variant="standard"
      sx={{ m: 1, minWidth: 60 }}
      className="intervalsMenuSelect vaultStatusMenu extraSmall"
    >
      <InputLabel id="intervalsMenuLabel">Interval</InputLabel>
      <Select
        labelId="intervalsMenuLabel"
        id="intervalsMenu"
        value={dateRange}
        onChange={(e) => setDateRange(e.target.value)}
        label="Interval"
      >
        {intervalsMenu.map((item) => {
          return (
            <MenuItem value={item} key={item}>
              {item}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
}
